import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001";

// Reads go through RTK Query (useGetMdSchedulesQuery / useGetMdScheduleByIdQuery
// in store/appApi.js) — these are the write-only mutations.

export const createMdSchdule = (data) =>
  axios.post(`${API_BASE_URL}/api/schdule/create`, data);

export const updateMdSchdule = (data) =>
  axios.post(`${API_BASE_URL}/api/schdule/update`, data);

export const deleteMdSchdule = (id) =>
  axios.delete(`${API_BASE_URL}/api/schdule/delete/${id}`);
